module.exports = __webpack_public_path__ + "static/Prominent-6d4837a93caad436d5ed84af5b7b503d.png";